import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import "./ReraModal.scss";

function ReraModal({ showReraModal, setShowReraModal, pdfUrl }) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, "", "/");
    }
    setTimeout(() => {
      setShowReraModal(false);
      setIsClosing(false);
    }, 300); // Match this with CSS animation duration
  };

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (typeof document !== 'undefined') {
      if (showReraModal) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }
      return () => {
        document.body.style.overflow = "unset";
      };
    }
  }, [showReraModal]);

  if (!showReraModal) return null;

  return (
    <div className="rera-modal-overlay" onClick={handleClose}>
      <div
        className={`rera-modal-content ${isClosing ? "closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="rera-modal-close" onClick={handleClose}>
          <CloseOutlined />
        </button>
        <div className="rera-modal-body">    
          {/* {pdfUrl?.map((url, index) => ( */}
            <iframe frameBorder="0" src={(pdfUrl || '/pdfs/Enchanted/Rera-Certificate.pdf') + '?#toolbar=0'} alt="RERA Certificate" />
          {/* ))} */}
        </div>
      </div>
    </div>
  );
}

export default ReraModal;
